<template>
  <svg
    class="wh-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :style="sizeStyle"
    v-html="path"
  ></svg>
</template>

<script>
// Lucide-style line icons used across the working-hours editor. Mirrors the
// icon set from the approved design mock so markup can reference them by name
// (<WhIcon name="clock" />) instead of inlining SVG paths everywhere.
const ICONS = {
  x: '<path d="M18 6 6 18M6 6l12 12"/>',
  chevL: '<path d="m15 18-6-6 6-6"/>',
  chevR: '<path d="m9 18 6-6-6-6"/>',
  chevDown: '<path d="m6 9 6 6 6-6"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  door:
    '<path d="M3 21h18"/><path d="M6 21V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v17"/><path d="M12 12h.01"/>',
  repeat:
    '<path d="m17 2 4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  pencil:
    '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
  trash:
    '<path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  note: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>',
  calendar:
    '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>',
  coffee:
    '<path d="M10 2v2M14 2v2M16 8a4 4 0 0 1 0 8h-1"/><path d="M3 8h13v6a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/>',
  plane:
    '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>',
};

export default {
  name: "WhIcon",
  props: {
    name: { type: String, required: true },
    // Optional explicit pixel size; otherwise the icon scales with font-size.
    size: { type: [Number, String], default: null },
    strokeWidth: { type: [Number, String], default: 1.9 },
  },
  computed: {
    path() {
      return ICONS[this.name] || "";
    },
    sizeStyle() {
      if (this.size == null) return null;
      const s = typeof this.size === "number" ? `${this.size}px` : this.size;
      return { width: s, height: s };
    },
  },
};
</script>

<style scoped>
.wh-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: middle;
  flex: none;
}
</style>
